import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { commonUrl } from '../../Utils/StaticURLs';
import FontSelector from '../FontSelector/FontSelector';
import './Branding.css';
import { TabContainer } from './TabContainer';

const BrandingSection = (props) => {
	const [designSettings, setDesignSetting] = useState({});
	const [tab, setTab] = useState([]);
	const [colorList, setColorList] = useState(null);
	const [filteredItemList, setFilteredItemList] = useState(null);
	const [tabName, setTabname] = useState('');
	const [defaultColor, setDefaultColor] = useState('');
	const [userSelectedOption, setUserSelectedOption] = useState({
		baseColor: '',
		trimColor: '',
		threadColor: '',
		tripMaterial: '',
	});
	const [fontList, setFontList] = useState(null);
	const [selectedFont, setSelectedFont] = useState('');
	const [keyNames, setKeyNames] = useState({
		backgroundColor: 'baseWebColor',
		defaultColor: 'baseMfgColorCode',
		webColor: 'baseWebColor',
	});
	const [tripMaterialList, setTripMaterialList] = useState(null);
	const [tabDetails, setTabDetails] = useState({});
	const [upchargeAmt, setUpchargeAmt] = useState('');
	const [selectFont, setSelectFont] = useState(false);

	useEffect(() => {
		setDesignSetting(
			props.selectedTemplate && props.selectedTemplate.designSettings
		);
	}, [props.selectedTemplate, JSON.stringify(props.selectedTemplate)]);

	useEffect(() => {
		let tabs = [];
		let branding = (props.stoleMeta && props.stoleMeta.branding) || {};
		designSettings &&
			designSettings.tabNavigationSettings &&
			designSettings.tabNavigationSettings.forEach((tab) => {
				let nav = { ...tab };
				nav.tabTitle = branding && branding[tab.key].tabTitle;
				tabs.push(nav);
			});
		setTab(tabs);
		setSelectedFont(
			designSettings && designSettings.data && designSettings.data.font
		);
	}, [JSON.stringify(designSettings)]);

	useEffect(() => {
		tab && getRequiredDetails(props.brandingTab);
	}, [JSON.stringify(tab), props.brandingTab]);

	useEffect(() => {
		props.getTabName(tabName);
		getRelatedOptions(tabName);
		let data = designSettings && designSettings.data;
		let keys = {};
		let color = '';
		switch (tabName) {
			case 'BaseColor':
				keys = {
					backgroundColor: 'baseWebColor',
					defaultColor: 'baseMfgColorCode',
					webColor: 'baseWebColor',
				};
				color = userSelectedOption.baseColor || data.baseColorId;
				break;
			case 'TrimColor':
				keys = {
					backgroundColor: 'trimWebColor',
					defaultColor: 'trimMfgColorCode',
					webColor: 'trimWebColor',
				};
				color = userSelectedOption.trimColor || data.trimColorId;
				break;
			case 'FontThread':
				keys = {
					backgroundColor: 'threadWebColor',
					defaultColor: 'threadMfgColorCode',
					webColor: 'threadWebColor',
				};
				color = userSelectedOption.threadColor || data.threadColorId;
				break;
			case 'TipMaterial':
				keys = {
					backgroundColor: '',
					defaultColor: 'tipMaterialCode',
					webColor: '',
				};
				color = userSelectedOption.tripMaterial || data.tipMaterialCode;
				break;
			default:
				break;
		}
		setKeyNames(keys);
		setDefaultColor(color);
		setTabDetails(
			(props.stoleMeta &&
				props.stoleMeta.branding &&
				props.stoleMeta.branding[tabName]) ||
				{}
		);
	}, [
		JSON.stringify(colorList),
		tabName,
		JSON.stringify(userSelectedOption),
		JSON.stringify(tripMaterialList),
		JSON.stringify(designSettings),
	]);

	useEffect(()=>{
		setFontList(props.fontList)
	},[props.fontList]);

	const getRequiredDetails = (key) => {
		let details = tab && tab[key] && tab[key].types;
		setTabname((tab && tab[key] && tab[key].key) || '');
		details &&
			details.forEach((type) => {
				if (type === 'colorList') {
					if (props.colorList && props.colorList.length) {
						setColorList(props.colorList);
					} else {
						if (!colorList) {
							let key = designSettings && designSettings[type];
							props.setLoading(true);
							axios
								.get(commonUrl + '/' + key + '.json')
								.then((res) => {
									props.setLoading(false);
									setColorList(res.data.colors);
								})
								.catch((err) => {
									props.setLoading(false);
									console.log(err);
								});
						}
					}
				} else if (type === 'fontList') {
					if (props.fontList && props.fontList.length) {
						setFontList(props.fontList);
					} else {
						props.getFontList();
					}
				} else if (type === 'tipMaterialList') {
					if (!tripMaterialList) {
						let key = designSettings && designSettings[type];
						props.setLoading(true);
						axios
							.get(commonUrl + '/' + key + '.json')
							.then((res) => {
								props.setLoading(false);
								setTripMaterialList(res.data.TipMaterials);
								let groupCode =
									res.data &&
									res.data.TipMaterials &&
									res.data.TipMaterials[0] &&
									res.data.TipMaterials[0].groupCode;
								let assetGroup =
									props.assetGroups &&
									props.assetGroups.find((asset) => {
										return asset.groupCode === groupCode;
									});
								setUpchargeAmt(assetGroup && assetGroup.upchargeAmt);
							})
							.catch((err) => {
								props.setLoading(false);
								console.log(err);
							});
					}
				}
			});
	};

	const getRelatedOptions = (tabName) => {
		let colors = [];
		switch (tabName) {
			case 'BaseColor':
				colors = filterData(
					colorList,
					designSettings.baseColorExcludeList,
					'colorId'
				);
				colors = colors && colors.filter((color) => color.baseWebColor);
				setFilteredItemList(colors);
				break;
			case 'TrimColor':
				colors = filterData(
					colorList,
					designSettings.trimColorExcludeList,
					'colorId'
				);
				colors = colors && colors.filter((color) => color.trimWebColor);
				setFilteredItemList(colors);
				break;
			case 'FontThread':
				colors = filterData(
					colorList,
					designSettings.threadColorExcludeList,
					'colorId'
				);
				colors = colors && colors.filter((color) => color.threadWebColor);
				setFilteredItemList(colors);
				break;
			case 'TipMaterial':
				setFilteredItemList(
					[{activeFlag: "y",
					groupCode: "tip-material",
					imagePath: props.stoleMeta && props.stoleMeta.image && props.stoleMeta.image.noneImagePath || '',
					tipMaterialCode: "none",
					tipMaterialName: "None"},
					...filterData(
						tripMaterialList,
						designSettings.tipMaterialExcludeList,
						'tipMaterialCode',
						false
					)]
				);
				break;
			default:
				break;
		}
	};

	const filterData = (list, excludeList, key, sort = true) => {
		let options = (list && [...list]) || [];
		if (list && list.length && excludeList && excludeList.length) {
			options =
				list.filter((col) => {
					return (
						excludeList &&
						!excludeList.find((id) => {
							return col[key] === id;
						})
					);
				}) || [];
		}
		sort && options.sort((a, b) => a.sort - b.sort);
		return options;
	};

	const storeUserSelectedItem = (code, id, name, webColor = null) => {
		let data = {};
		switch (tabName) {
			case 'BaseColor':
				setUserSelectedOption({
					...userSelectedOption,
					baseColor: id,
				});
				data.baseColorId = id;
				data.baseMfgColorCode = code;
				data.baseColorName = name;
				data.baseWebColor = webColor;
				break;
			case 'TrimColor':
				setUserSelectedOption({
					...userSelectedOption,
					trimColor: id,
				});
				data.trimColorId = id;
				data.trimMfgColorCode = code;
				data.trimColorName = name;
				data.trimWebColor = webColor;
				break;
			case 'FontThread':
				setUserSelectedOption({
					...userSelectedOption,
					threadColor: id,
				});
				data.threadColorId = id;
				data.threadMfgColorCode = code;
				data.threadColorName = name;
				data.threadWebColor = webColor;
				if(name !== designSettings.data.threadColorName){
					let zones = props.selectedTemplate && props.selectedTemplate.zones;
					zones && zones.map((zone)=>{
						let zoneCode = zone.zoneCode;
						if(props.zoneImagePath[zoneCode])
						props.setZoneImagePath((images)=>({...images,[zoneCode]:''}))
					})
				}
				break;
			case 'TipMaterial':
				setUserSelectedOption({
					...userSelectedOption,
					tripMaterial: code,
				});
				data.designImageUrl = code === "none" ? '' : id;
				data.tipMaterialCode = code === "none" ? '' : code;
				data.tipMaterialName = code === "none" ? '' : name;
				data.upchargeAmt = id && code !== "none" ? upchargeAmt : 0;
				break;
			default:
				break;
		}
		let settings = { ...designSettings };
		settings.data = { ...settings.data, ...data };
		props.updateSelectedData(settings);
	};

	const OptionSelect = (selected) => {
		designSettings.data = {
			...designSettings.data,
			...{
				font: (selected && selected.consumerFontCode) || '',
				pulseFont: (selected && selected.pulseFont) || '',
			},
		};
		props.updateSelectedData(designSettings);
		setSelectedFont((selected && selected.consumerFontCode) || '');
		setSelectFont(false)
	};
	return (
		<Tabs
			fill
			justify
			defaultActiveKey={0}
			transition={false}
			id='noanim-tab-example'
			onSelect={(k) => props.setBrandingTab(Number.parseInt(k))}
			data-test='component-tabs'
			unmountOnExit={true}
			activeKey={props.brandingTab}>
			{tab &&
				tab.map((nav, index) => (
					<Tab eventKey={index} title={nav.tabTitle} key={index}>
						{tabName === 'FontThread' && (
							<FontSelector
								options={fontList}
								OptionSelect={OptionSelect}
								selectedOption={selectedFont}
								title={tabDetails['title.font']}
								setSelectFont={setSelectFont}
								selectFont={selectFont}
								stoleMeta={props.stoleMeta}
							/>
						)}
						<TabContainer
							title={tabDetails['title.threadColor'] || tabDetails.title}
							description={tabDetails.description}
							displayItemList={filteredItemList}
							defaultColor={defaultColor}
							onItemSelect={storeUserSelectedItem}
							keyNames={keyNames}
							showImage={tabName === 'TipMaterial'}
							upchargeAmt={tabName === 'TipMaterial' ? upchargeAmt : ''}
							stoleMeta={props.stoleMeta}
						/>
					</Tab>
				))}
		</Tabs>
	);
};

export default React.memo(BrandingSection);
